module.exports = __webpack_public_path__ + "static/media/apartment.e35184fc.svg";